import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import logo from '../../assets/mtlawllc-logo-header.png';

export const Root = styled(Box)({
    background: 'linear-gradient(180deg, #D8E8EF 0%, #C7D6E2 100%)',
    minHeight: '100vh',
    '& .content': {
        paddingTop: '104px',
        width: '100%',
    },
    '& .content-text': {
        paddingTop: '104px',
        width: '100%',
        height: '100vh',
    },
    '& .card': {
        marginTop: '40px',
        width: '800px',
        backgroundColor: '#fff',
    },
    '& .logo': {
        width: '187px',
        height: '43px',
        background: `url(${logo}) no-repeat center top/cover`,
    },
    '& .line': {
        width: '100%',
        height: '1px',
        margin: '45px 0 40px 0 ',
        backgroundColor: '#A1A1A1',
        opacity: '0.13',
    },
    '& .completeWapper': {
        width: '100%',
        height: '100%',
        '& .complete': {
            marginTop: '100px',
            width: '600px',
            height: '150px',
            padding: '40px',
            color: '#005E96',
            backgroundColor: '#fff',
            '& .text': {
                marginLeft: '10px',
                fontSize: '16px',
                fontWeight: 'bold',
            }
        }
    },
    '& .bgW': {
        width: '100%',
        backgroundColor: '#fff',
    },
    '& .tableTool': {
        padding: '16px',
        backgroundColor: '#FAFAFA',
        borderBottom: '1px solid #D8D8D8',
        '& .searchWapper': {
            border: '1px solid #CCCCCC',
            borderRadius: '3px',
            width: '285px',
            height: '38px',
            '& .search': {
                height: '32px',
                color: '#58727C',
                padding: '0 10px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            border: '1px solid #CCCCCC',
        },
    },
    '& .tableWapper': {
        width: '100%',
        backgroundColor: '#fff',
    },
    '& .itemWapper': {
        width: '135px',
        height: '139px',
        backgroundColor: '#fff',
        cursor: 'pointer',
        margin: '0 20px',
        boxShadow: '1px 1px 7px 2px rgba(0,0,0,0.12)',
        borderRadius: '13px',
    },
    '& .itemWapper:nth-child(1)': {
        textAlign: 'center'
    },
    '& .itemWapper:hover': {
        cursor: 'pointer',
        margin: '0 20px',
        backgroundColor: '#009CEE',
        color: '#fff',
    },
    '& .finalStatus': {
        width: '90px',
        height: '26px',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'bold',
        borderRadius: '50px',
        backgroundColor: '#18C6FF'
    },
    '& .draftStatus': {
        width: '90px',
        height: '26px',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'bold',
        borderRadius: '50px',
        backgroundColor: '#43D79E'
    },
    '& .del': {
        color: '#9B9B9B',
        cursor: 'pointer',
    },
    '& .loadingWapper': {
        width: '800px',
        padding: '40px',
        '& .loadingTitle': {
            marginBottom: '40px',
            color: '#0060A0',
            fontWeight: 'bold',
        },
    },
    '& .hint-text': {
        color: 'gray',
        fontWeight: 'bold',
        fontSize: '18px'
    },
});